<template>
  <div class="page-content">
    <el-row>
      <el-breadcrumb separator="/" class="breadcrumb">
        <el-breadcrumb-item>活动信息</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ActivityApproval/:id' }">活动审批</el-breadcrumb-item>
        <el-breadcrumb-item>活动审批详情</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
		<ActivityHeader
      style="background-color: #fff"
			:isApprovalDetail="true"
			:data="activityDetail.details"
			:allData="activityDetail"
		/>
		<div style="padding: 20px;margin-top: 20px;background-color: #fff">
			<ActivityTable
				:headerData="headerData"
        :data="activityDetail.campaignProductList || []"
				:titleData="activityDetail.details"
				:canEdit="false"
				:needActivityState="needActivityState"
			>
			</ActivityTable>
		</div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ActivityHeader from 'components/activityHeader/activityHeader'
import Breadcrumb from "components/breadcrumb/breadcrumb";
import Pagination from "components/pagination/pagination";
import ActivityTable from "components/activityTable/activityTable";
import ActivityMixin from '@/mixins/activityMixin.js';
import Shopname from "components/shopname/Shopname";
import { getSinceThreeMonth } from "@/libs/date";
import { getLoginType } from "@/libs/until";
export default {
  name: "ActivityReview",

	mixins: [
		ActivityMixin
	],

  components: {
    Breadcrumb,
    Shopname,
		ActivityTable,
		ActivityHeader
  },

  data() {
    return {
      logintype: getLoginType(),
      type: 1,
      pagination: {
        size: 10,
        current: 1
      },
      breadcrumbArray: ["活动信息", "活动审批", '活动审批详情'],
    };
  },
  methods: {
    ...mapActions([
      "reqActivityCat",
      "reqPlateList",
			"reqActivityDetail",
			"reqActivityCcDetail",
      "reqActivityPeople",
      "reqActivityApproval",
      "reqActivitySetting",
			"getHcmApprovalByRelated"
    ]),
  },
	mounted() {},

  computed: {
    ...mapGetters([
      "activityCount",
      "getActivityDetail",
      "getActivityPerson",
    ]),
		...mapState({
			activityDetail: state => state.activityApproval.activityDetail
		}),
  },

  async created() {
		const type = this.$route.query.type;
		const params = {
			id: this.$route.params.id
		}
		type === '1' ? await this.reqActivityCcDetail(params) : await this.reqActivityDetail(params)
		this.reqActivityPeople();
		this.echoTableData(this.activityDetail.campaignProductList, this.activityDetail.details.campaignway, true);
  },

  mounted() {}
};
</script>

<style lang="scss">
@import "style/activityApproval.scss";
</style>
